import clsx from 'clsx';
import styles from 'components/UI/V3/Dropdown/Footer/DropdownFooter.module.scss';
import React from 'react';

interface DropdownFooterProps {
    children: React.ReactNode;
    className?: string;
}

export const DropdownFooter: React.FC<DropdownFooterProps> = ({ children, className }) => {
    return <div className={clsx(styles.root, className)}>{children}</div>;
};
